import React from 'react';
import Tab, { TabProps } from '@mui/material/Tab';
import { useTabStyles } from './toolbar-button.styles';

export const ToolbarButton = (props: TabProps) => {
  const sx = useTabStyles(props.sx);
  return <Tab {...props} sx={sx} />;
};
